<template>
    <ul class="list-unstyled">
        <li v-if="modulesNumber > 0">
            <small>
                <b-icon icon="list"></b-icon>
                <span class="font-weight-bold">
                    {{ modulesNumber }} {{ transChoice("home.module", modulesNumber) }}
                </span>
            </small>
        </li>
        <li v-if="missionsNumber > 0">
            <small>
                <b-icon icon="star"></b-icon>
                <span class="font-weight-bold">
                    {{ missionsNumber }} {{ transChoice("home.mission", missionsNumber) }}
                </span>
            </small>
        </li>
    </ul>
</template>

<script>
  export default {
      name: "ServiceDetail",
      props:{
          modulesNumber: Number,
          missionsNumber: Number
      }
  }
</script>

<style scoped lang="scss">
</style>
